export const priceSplitter = (number: number) =>
  number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export const errMessageMapper = (err: any) => {
  if (err.response) {
    const errMessage = err?.response?.data?.message;

    if (typeof errMessage === "string") return errMessage;

    let messages = "";
    Object.keys(errMessage).forEach((key) => {
      messages +=
        errMessage[key]?.name + " " + errMessage[key]?.error + "\n\n" ??
        errMessage[key] + "\n";
    });

    return messages;
  }

  return;
};

export const CSVtoJSON = async (csvFile: File): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    try {
      const result: any[] = [];
      const reader = new FileReader();
      reader.readAsText(csvFile);
      reader.onload = () => {
        const file = reader.result;
        const lines = (file as string).split("\n");

        const headers = lines[0].split(",");
        headers[headers.length - 1] = headers[headers.length - 1].replace(
          "\r",
          ""
        );

        for (let i = 1; i < lines.length; i++) {
          const obj: { [key: string]: any } = {};
          const currentline = lines[i].split(",");

          for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j];
          }

          result.push(obj);
        }

        resolve(result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    } catch (error: any) {
      reject(error);
    }
  });
};

export const JSONtoCSV = (json: any[]) => {
  try {
    const header = Object.keys(json[0]);
    let csv = json.map((row) =>
      header
        .map((fieldName) => {
          const cleanedStr =
            String(row[fieldName]) !== "undefined"
              ? String(row[fieldName]).replace(/\r/g, "")
              : "";
          return JSON.stringify(cleanedStr);
        })
        .join(",")
    );
    csv.unshift(header.join(","));
    return csv.join("\r\n");
  } catch (error) {
    console.error("Error converting JSON to CSV:", error);
    throw error;
  }
};
